import { CSSProperties } from 'react';
import styled from 'styled-components';

import { TBorderRadius, TBoxShadow, TSpacing, TTypography } from './types';
import { customMarginStyles, customPaddingStyles } from '../../../styles/Shared/SharedStyles';
import { handleTypography } from '../../../styles/Shared/TypographyStyles';
import Theme from '../../../styles/Theme/Theme';

type TSCustomProps = {
    borderRadius?: TBorderRadius['borderRadius'] | CSSProperties;
    boxShadow?: TBoxShadow['boxShadow'] | CSSProperties;
    bg?: keyof typeof Theme.color;
    customColor?: keyof typeof Theme.color;
    customBorderColor?: keyof typeof Theme.color;
};

export const Box = styled.div<CSSProperties & TSpacing & TSCustomProps & TTypography>`
    // Typography
    ${(props: TTypography) => handleTypography(props)}

    display: ${({ display }) => (display ? display : null)};
    // Flex
    flex: ${({ flex }) => (flex ? flex : null)};
    flex-direction: ${({ flexDirection }) => (flexDirection ? flexDirection : null)};
    flex-wrap: ${({ flexWrap }) => (flexWrap ? flexWrap : null)};
    flex-grow: ${({ flexGrow }) => (flexGrow ? flexGrow : null)};
    justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : null)};
    align-items: ${({ alignItems }) => (alignItems ? alignItems : null)};
    align-content: ${({ alignContent }) => (alignContent ? alignContent : null)};
    align-self: ${({ alignSelf }) => (alignSelf ? alignSelf : null)};
    // Position
    position: ${({ position }) => (position ? position : null)};;
    top: ${({ top }) => (top ? top : null)};
    right: ${({ right }) => (right ? right : null)};;
    bottom: ${({ bottom }) => (bottom ? bottom : null)};;
    left: ${({ left }) => (left ? left : null)};;
    // Width
    width: ${({ width }) => (width ? width : null)};
    min-width: ${({ minWidth }) => (minWidth ? minWidth : null)};
    max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : null)};
    // Height
    height: ${({ height }) => (height ? height : null)};
    min-height: ${({ minHeight }) => (minHeight ? minHeight : null)};
    max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : null)};
    // Margin
    ${customMarginStyles}
    // Padding
    ${customPaddingStyles}
    // Others
    order: ${({ order }) => (order ? order : null)};
    color: ${({ color, customColor, theme }) => {
        if (customColor) return theme.color[customColor];
        return color;
    }};
    background-color: ${({ backgroundColor, bg, theme }) => {
        if (bg) return theme.color[bg];
        return backgroundColor;
    }};
    text-align: ${({ textAlign }) => (textAlign ? textAlign : null)};
    transform: ${({ transform }) => (transform ? transform : null)}; ;
    z-index: ${({ zIndex }) => (zIndex ? zIndex : null)}; ;
    // Border
    border: ${({ border }) => (border ? border : null)};
    border-color: ${({ borderColor, customBorderColor, theme }) => {
        if (customBorderColor) return theme.color[customBorderColor];
        return borderColor;
    }};
    border-radius: ${({ borderRadius, theme: { radius } }) => borderRadius ? (radius[borderRadius] ? radius[borderRadius] : borderRadius) : null};
    overflow: ${({ overflow }) => (overflow ? overflow : null)};
    box-shadow: ${({ boxShadow, theme }) => boxShadow ? (theme.shadow[boxShadow] ? theme.shadow[boxShadow] : boxShadow) : null};
`;

export default Box;
